import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {logout} from '../../Helpers';
import {User} from 'jugacu-lib';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

  @Input() authorized: boolean;
  @Input() authenticated: boolean;
  @Input() authenticating: boolean;
  @Input() user: User;

  constructor(
    private readonly store: Store
  ) {
  }

  ngOnInit() {
  }

  async logout() {
    await logout(this.store);
  }

}
